import React from "react";
import "./style.scss";

const Spinner = () => {
  return <div className="spinner"></div>;
};

export default Spinner;
